import { createBrowserRouter } from 'react-router-dom';
import AppShell from '../AppShell';
import Router from '../routes/Router';

/**
 * React Router v6 data API ile oluşturulmuş router.
 *
 * @param {object} [opts] — `createBrowserRouter` ikinci argümanı (ör. `future`)
 * @returns {import('react-router-dom').DataRouter}
 */
export function createAppRouter(opts = {}) {
  return createBrowserRouter(
    [
      {
        element: <AppShell />,
        children: Router,
      },
    ],
    opts
  );
}
